import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@driftt/tide-core'
import { withRouter } from 'react-router-dom'
import './style.css'

class DefinedScopesContent extends Component {
  static propTypes = {
    appId: PropTypes.string.isRequired
  }

  render() {
    const { appId, history } = this.props

    return (
      <div className="app-submit-view-accordion-content">
        <p className="app-submit-view-accordion-content-description">
          Your App needs at least one defined scope so that you have the correct permissions to access the Drift data that your app needs.
        </p>
        <Button
          onClick={() => history.push(`/app/${appId}/oauth`)}
          type="secondary"
          size="small"
          className="defined-scopes-content-button">
          View Scopes
        </Button>
      </div>
    )
  }
}

export default withRouter(DefinedScopesContent)
